import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { HlPercentageTypeEnum } from '@gtpl/shared-models/common-models';
export class HlPercentageDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Hl Percentage should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  hlPercentageId?: number;

  @ApiProperty()
  @IsNotEmpty({message:"Minimun Grade should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  minGrade: number;

  @ApiProperty()
  @IsNotEmpty({message:"Maximun Grade should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  maxGrade: number;

  @ApiProperty()
  @IsNotEmpty({message:"Hl Percentage should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  hlPercentage: number;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty()
  type?:HlPercentageTypeEnum
}

